// eslint-disable-next-line import/prefer-default-export
export const styles = {
  cardIcon: {
    width: '400px',
    textAlign: 'start',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardBody: {
    display: 'flex',
    alignItems: 'flex-start',
  },

  dateContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    width: '12%',
  },
  date: {
    fontSize: '12px',
    color: 'gray',
    fontFamily: 'Nunito , sans-serif',
  },
  description: {
    fontFamily: 'Nunito, sans-serif',
    width: '88%',
    fontSize: '14px',
  },
  title: {
    fontFamily: 'Nunito, sans-serif',
    fontWeight: 'bold',
  },
  mainContainer: {
    minHeight: '150px',
  },
};
